<template>
  <div
    class="inline-commitment-with-progress"
    :style="{
      'opacity': active ? 1.0 : 0.6
    }">

    <div class="inline-commitment-with-progress__content">
      <div style="flex: 0 0 60px">
        <div
          class="colorbox"
          :style="background_image_css"
          @click="onSelectCommitment">
          <!--
          <font-awesome-icon
            v-show="selected"
            icon="brush"
            color="white"
            style="stroke: black; stroke-width: 30;s troke-opacity: 0.5;"/>
          -->
        </div>
        <InlineCommitmentStatus :commitment-meta="commitment.meta" />
      </div>

      <div class="w-100">
        <div class="small-caps-goal-title">
          {{goal_meta.name}} &mdash;
        </div>
        <span :style="{color: commitmentStatusText.color}">
          {{commitmentStatusText.text}}
        </span>
        <router-link :to="'/goal/' + goalId + '/kanban#' + commitmentId">
          {{commitment.meta.name}}
        </router-link>
      </div>

      <div>
        <font-awesome-icon icon="wrench" @click="onEditCommitment" class="inline-icon" />
        <!--
        <font-awesome-icon icon="link" @click="onGoToCommitment" class="inline-icon" />
        <font-awesome-icon icon="trash-alt" @click="removeCommitment" class="inline-icon" />
        -->
      </div>
    </div>

    <!--
    <template v-if="active">
      <font-awesome-icon
        icon="pause"
        @click="onActivateCommitment(false)"
        class="inline-icon"
        v-tooltip="'Deactivate commitment. This will exclude this<br /> commitment from automatic planning.'" />
    </template>
    <template v-else>
      <font-awesome-icon
        icon="play"
        @click="onActivateCommitment(true)"
        class="inline-icon"
        v-tooltip="'Reactive commitment and include into automatic planning.'" />
    </template>
    -->

    <!-- <span v-if="!active">(inactive)</span> -->
    <!-- {{ commitmentText(commitment) }} -->
    <!--
    <el-switch
    v-model="commitment.showCommitment"
    active-text="Show"
    inactive-text="Hide"
    @change="updateCommitmentPositions(goal.goalId)">
    </el-switch>
    -->

    <!-- <pre class="mini-pre"> {{commitment}} </pre> -->

    <!-- TODO: connect data to progressbar -->
    <div
      v-if="commitment.type === 'TIME_BASED_TASKLIST'"
      class="clearfix"
      style="height: 16px; /* clear: both; */">
      <InlineCommitmentProgress
        :commitmentMeta="commitment.meta"
        :goalId="goalId" />
    </div>
  </div>
</template>

<script>
import InlineCommitmentProgress from '@/components/GoalPage/Elements/InlineCommitmentProgress'
import InlineCommitmentStatus from "@/components/GoalPage/Elements/InlineCommitmentStatus";

// TODO: Only show active / inactive for commitments that are auto-planned
// TODO: Only show active / inactive for assigned user (for my commitments)

// TODO: show picture (if no effort pic found, show goal pic) ?

export default {
  props: {
    active: { default: true },
    selected: { default: false },
    goalId: { required: true },
    commitmentId: { required: true },
  },
  // mixins: [CommitmentMixin],
  computed: {
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },
    commitment() {
      /* Doppelt, eigentlich sind alle daten schon da */
      return this.$models.commitment.with({ goalId: this.goalId }).getNodeFull( this.commitmentId )
    },
    commitmentStatusText() {
      // let { color, text } = this.commitmentStatusColorAndText( this.commitment );
      // return {
      //   text: text,
      //   fontFamily: "Arial", // TODO
      //   color: color
      // };
      return {
        text: '',
        fontFamily: "Arial",
        color: 'red'
      };
    },
    background_image_css() {
      return  this.commitment.picture
              ? {
                backgroundImage: 'url(' + this.commitment.picture + ')',
                backgroundSize: 'cover'
              } : {}
    }
  },
  methods: {
    onChangePosition(data) {
      this.$emit('change', data)
    },

    onEditCommitment() {
      this.$root.showUpdateModal('effort', {
        goalId: this.goalId,
        commitmentId: this.commitmentId
      });
    },

    onActivateCommitment(state) {
      console.log("onActivateCommitment", state)
      this.$models.commitmentMeta
        .with({ goalId: this.goalId })
        .update(this.commitmentId, {
          active: state
      })
    },

    onGoToCommitment() {
      this.$router.push('/goal/' + this.goalId + '/kanban')
      // http://localhost:8080/goal/Hf_E07azTam5gPQ2zoJxdw/kanban
    },

    removeCommitment() {
      console.log("todo");
      this.$emit('remove', { commitmentId: this.commitmentId });
    },

    onSelectCommitment() {
      if ( this.selected ) {
        this.$emit('select', null) /* unselect if already selected */
      } else {
        this.$emit('select', this.commitmentId || null)
      }
    }
  },
  components: {
    InlineCommitmentStatus,
    InlineCommitmentProgress,
  }
}
</script>

<style>
.inline-commitment-with-progress .colorbox {
  /* display: inline-block; */
  /* float: left; */
  width: 50px;
  height: 50px;
  border: 1px solid rgb(128, 128, 128);
  vertical-align: middle;
  text-align: center;
  cursor: pointer;

  /* width: 40px; */
  /* height: 40px; */
  border-radius: 3px;

  background-color: #e6e6e6;
  background-position: center;
  background-repeat: no-repeat;

  /* Default image */
  background-size: contain;
  background-image: url('../../assets/commitment_placeholder.png');
}
.inline-commitment-with-progress .colorbox svg {
  width: 50px;
  height: 50px;
  padding: 10px;
}
.inline-commitment-with-progress {
}
.inline-commitment-with-progress__content {
  display: flex;
  justify-content: space-between;
}
</style>
